export default __webpack_public_path__ + "static/media/ROM SYLLABUS_2026-27 CLASS 6.6c30ba80.pdf";